module.exports = __webpack_public_path__ + "media/images/icons/thumb-down-5b66f09d840dde584e58db717f633ff4.svg";